import { Component, inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LinkOutcomesDialogComponent } from './link-outcomes-dialog/link-outcomes-dialog.component';
import { take } from 'rxjs/operators';
import { HubRecordEditorBase } from '../../_hub_record_editor_base';
import { Goal2030Model, ProjectLinkedOutcomeModel } from '../../../../../hub_schema/hubTypes';
import { HubLovService } from '../../../../core/services/hub-lov.service';
import { LinkedOutcomeTree } from './types/linked-outcome-tree';

@Component({
  selector: 'app-linked-outcomes-panel',
  templateUrl: './linked-outcomes-panel.component.html',
  styleUrl: './linked-outcomes-panel.component.scss',
  standalone: false
})
export class LinkedOutcomesPanelComponent extends HubRecordEditorBase implements OnInit {
    private dialogService: MatDialog = inject(MatDialog);
    private hubLovService: HubLovService = inject(HubLovService);
    public strategyLinkedOutcomeTree: LinkedOutcomeTree | undefined;
    public projectLinkedOutcomeTree: LinkedOutcomeTree | undefined;
    private goals: Goal2030Model[] | undefined;

    private get linkedOutcomes(): ProjectLinkedOutcomeModel[] {
        return this.projectEditForm?.controls.linkedOutcomes.value;
    }

    public ngOnInit(): void {
        this.hubLovService.get2030Goals().pipe(take(1)).subscribe((goals: Goal2030Model[]) => {
            this.goals = goals;
            this.refreshLinkedOutcomes();
        });
    }

    private refreshLinkedOutcomes(): void {
        this.strategyLinkedOutcomeTree = new LinkedOutcomeTree('Strategy', this.goals!,
            this.linkedOutcomes.filter(lo => lo.project!.projectType!.name === 'Strategy'));

        this.projectLinkedOutcomeTree = new LinkedOutcomeTree('Project', this.goals!,
            this.linkedOutcomes.filter(lo => lo.project!.projectType!.name === 'Project'));

    }

    public openLinkOutcomesDialog(): void {
        const dialogRef: MatDialogRef<LinkOutcomesDialogComponent> = this.dialogService.open(LinkOutcomesDialogComponent, {
            width: '95vw',
            maxWidth: 'none',
            height: '95vh'
        });
        dialogRef.afterClosed().pipe(take(1)).subscribe(() => {
            this.refreshLinkedOutcomes();
        });
    }

    public removeLink(outcome: ProjectLinkedOutcomeModel) {
        const linkedOutcomes = this.linkedOutcomes.filter(lo => lo !== outcome);
        this.projectEditForm!.controls.linkedOutcomes.setValue(linkedOutcomes);
        this.projectEditForm!.controls.linkedOutcomes.markAsDirty();
        this.projectEditForm!.controls.linkedOutcomes.updateValueAndValidity();
        this.refreshLinkedOutcomes();
    }
}
